"use client";

import {
  PARTNER_REVEAL_MOTION_CLASS,
  PARTNER_REVEAL_STAGGER_MS,
  partnerColumnRevealStyle,
} from "@/components/partners/partner-column-reveal";
import { ActionButton } from "@/components/ui/action-button";
import { useScrollAnimate } from "@/hooks/use-scroll-animate";
import Image from "next/image";

export function BrilliantSection() {
  const textAnimate = useScrollAnimate();
  const imageAnimate = useScrollAnimate();

  return (
    <section className="bg-surface-200 py-12 md:py-16 lg:py-20">
      <div className="mx-auto px-3 sm:px-4 max-w-[1024px]">
        <div className="flex flex-col md:flex-row items-center md:items-center gap-8 md:gap-12">
          {/* Left: Text content — slides in from left */}
          <div
            ref={textAnimate.ref}
            className={`w-full md:w-2/5 text-center md:text-left ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(textAnimate.isVisible, "left")}
          >
            <div className="mb-4">
              <Image
                src="/images/marketing/partners/brilliant/logo.webp"
                alt="Brilliant logo"
                width={200}
                height={60}
                className="inline-block h-8 md:h-12 w-auto"
              />
            </div>
            <p className="text-base md:text-lg text-gray-700 text-pretty mb-6">
              Interactive and visual STEM courses that spark curiosity, go beyond rote formulas, and
              develop great problem-solvers. Grant-funded and totally free for K-12 schools.
            </p>
            <ActionButton href="https://educator.brilliant.org/">Get it for free!</ActionButton>
          </div>

          {/* Right: Hero image — slides in from right */}
          <div
            ref={imageAnimate.ref}
            className={`w-full md:w-3/5 ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(imageAnimate.isVisible, "right", {
              delayMs: PARTNER_REVEAL_STAGGER_MS,
            })}
          >
            <div className="relative w-full">
              <Image
                src="/images/marketing/partners/brilliant/hero.webp"
                alt="Brilliant drag-and-drop coding interface"
                width={600}
                height={400}
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
